// extracted by mini-css-extract-plugin
export var chip = "_ch-0";
export var filterDropdown = "_ch-5";
export var filterItem = "_ch-6";
export var icon = "_ch-1";
export var removeButton = "_ch-3";
export var removeIcon = "_ch-4";
export var separator = "_ch-2";